<template>
  <div>
    <cancel-heading is-centered>Your On the Way</cancel-heading>
    <cancel-content is-centered>Learn how to turn leads into deals with Forefront.</cancel-content>

    <!-- TODO: Insert Video Here-->
  </div>
</template>

<script>
import CancelContent from "./components/CancelContent.vue";
import CancelHeading from "./components/CancelHeading.vue";

/**
 * NOTE: This is on hold because Kevin doesn't think it's a good idea
 */
export default {
  name: "OfferConfirmationWalkThru",
  components: {CancelHeading, CancelContent}
}
</script>

<style scoped>

</style>
